<template>
    <footer>
        <div class="d-flex flex-sb mag-auto">
			<section class="font-noto">
				<p>주식회사 노드블랙</p>
				<p>등록번호: 121-86-43159</p>
				<p>대표: 장성군</p>
			</section>

			<section class="font-mont">
				<!-- address -->
				<a class="font-noto">
					<span class="">A</span>
					<p>대구광역시 북구 호암로 51,<br>2층 대구창조경제혁신센터</p>
				</a>

				<!-- email -->
				<a href="mailto:info@nodeblack.io">
					<span class="">E</span>
					<p>info@nodeblack.io</p>
				</a>

				<!-- connect -->
				<a href="http://nodeblack.io/" target="_blank">
					<span class="">C</span>
					<p>nodeblack.io <i class="xi-external-link"></i></p>
				</a>
			</section>

			<section class="font-mont">
				<p>Copyright <i class="xi-copyright"></i>node.Bee 2022</p>
				<p>All Rights Reserved</p>
			</section>
		</div>
    </footer>
</template>

<script>
export default {}
</script>
